import { pick } from 'lodash'

import { toLines } from '../../../../common/utils'

const allergenSimpleDetailsFormInitialValues = allergen => ({
  ...pick(allergen, ['description', 'position', 'isExcludedFromSearch']),
  synonyms: toLines(allergen.synonyms),
})

export default allergenSimpleDetailsFormInitialValues
